<template>
  <div class="about-us">
    <div class="hero">
      <div class="container">
        <h3>Wij zijn Roosterplatform.</h3>
        <h1>Samen meer en betere zorg leveren</h1>
        <p>
          Wij zijn een enthousiast en hecht team. Onze kern werkt al meer dan 15
          jaar samen.
        </p>
        <p>
          Wij zien ons werk als topsport. Net als een Formule 1 team zijn wij
          scherp en competitief ingesteld. Staan we continu open voor nieuwe
          wegen en verbeteringen en dat is dan ook onze grote kracht. Wij staan
          continu open voor nieuwe wegen en verbeteringen en dat is onze grote
          kracht. Bovendien zijn we altijd bereid om van elkaar te leren en
          elkaar te verbeteren. Vertrouwen en respect staan bij ons hoog in het
          vaandel.
        </p>
        <p>
          Doordat we elkaar steunen, blijven motiveren en elkaar durven aan te
          spreken op onze eigen verantwoordelijkheden, hebben wij al veel mooie
          dingen met elkaar mogen bereiken in de afgelopen 15 jaar.
        </p>
        <p>
          De diverse talenten en brede ervaringen binnen het Roosterplatform
          team vullen elkaar perfect aan. Zo beschikken wij over zeer ervaren
          software ontwikkelaars, UX experts en gespecialiseerde planners die
          ook nog een achtergrond in de zorgsector hebben.
        </p>

        <p>
          Kortom, het is een feest om in dit transparante, deskundige en
          gezellige team te werken!
        </p>

        <img
          src="../assets/img/team/rp-team.png"
          alt=""
        >
      </div>
    </div>

    <!-- <div class="section primary extra-padding-bottom">
      <div class="container">
        <div class="section-title">
          <span>Wie zit er achter de schermen?</span>
          <h2>Dit zijn wij</h2>
        </div>
        <div class="team">
          <div class="member">
            <div class="picture">
              <img
                src="../assets/img/team/herman.jpg"
                alt=""
              >
            </div>
            <div class="sub-title">
              Herman de Jager
            </div>
            <div class="body opacity">
              CEO & Founder
            </div>
            <div class="description">
              <p>
                Gedreven, competatief, analytisch en technisch. Ik leer van elke
                ervaring! Gebruik je potentie door het maximale uit jezelf en de
                situatie te halen. Geniet van de reis.
              </p>
            </div>
          </div>
          <div class="member">
            <div class="picture">
              <img
                src="../assets/img/team/jonny.jpg"
                alt=""
              >
            </div>
            <div class="sub-title">
              Jonny Au
            </div>
            <div class="body opacity">
              Senior Software Developer
            </div>
            <div class="description">
              <p>
                Creative problem solver. Houdt van uitdaging, maak complex
                probleem simple. Nieuwsgierig naar nieuwe technieken. Ik zorg
                voor de architectuur met passende technieken binnen
                RoosterPlatform.
              </p>
            </div>
          </div>
          <div class="member">
            <div class="picture">
              <img
                src="../assets/img/team/eveline.jpg"
                alt=""
              >
            </div>
            <div class="sub-title">
              Eveline Hes
            </div>
            <div class="body opacity">
              Product & Implementatie
            </div>
            <div class="description">
              <p />
            </div>
          </div>

          <div class="member">
            <div class="picture">
              <img
                src="../assets/img/team/bjorn.jpg"
                alt=""
              >
            </div>
            <div class="sub-title">
              Bjorn Rietdijk
            </div>
            <div class="body opacity">
              Senior Software Developer
            </div>
            <div class="description">
              <p>
                Backend developer. Hou van uitdagingen, bug fixing en vind het
                leuk om nieuwe technieken te gebruiken. Draag zorg voor de
                implementatie van de planmotor, door elke keer nieuwe
                oplossingen te vinden en verbeteringen toe te passen.
              </p>
            </div>
          </div>
          <div class="member">
            <div class="picture">
              <img
                src="../assets/img/team/andries.jpg"
                alt=""
              >
            </div>
            <div class="sub-title">
              Andries Vivie
            </div>
            <div class="body opacity">
              Product Owner
            </div>
            <div class="description">
              <p />
            </div>
          </div>
          <div class="member">
            <div class="picture">
              <img
                src="../assets/img/team/fernando.jpg"
                alt=""
              >
            </div>
            <div class="sub-title">
              Fernando Moreira
            </div>
            <div class="body opacity">
              Senior Software Developer
            </div>
            <div class="description">
              <p>
                .Net Backend Developer Met een passie voor Clean code en good
                practices. Geniet van automatisering en vereenvoudiging. Ik
                verzorg de integraties tussen Roosterplatform en onze partners.
              </p>
            </div>
          </div>

          <div class="member">
            <div class="picture">
              <img
                src="../assets/img/team/willem.jpg"
                alt=""
              >
            </div>
            <div class="sub-title">
              Willem Swanepoel
            </div>
            <div class="body opacity">
              Back-end developer
            </div>
            <div class="description">
              <p>
                Gepassioneerde, ervaren en getalenteerde back-end developer.
                Houdt van complexe systemen en uitdagende omstandigheden.
                Verantwoordelijk voor de backend integraties tussen systemen bij
                Roosterplatform.
              </p>
            </div>
          </div>

          <div class="member">
            <div class="picture">
              <img
                src="../assets/img/team/said.jpg"
                alt=""
              >
            </div>
            <div class="sub-title">
              Said Zadou
            </div>
            <div class="body opacity">
              Product designer
            </div>
            <div class="description">
              <p>
                Multidisciplinaire designer met veel ervaring in de digitale
                wereld. Ik heb voor verschillende startups, scale-ups en
                corporates gewerkt als UI/UX designer.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div class="section primary extra-padding-bottom">
      <app-clients-grid />
    </div>
    <!-- <div class="section grey-light extra-padding-bottom">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-5 mission-vision-block">
            <div class="icon">
              <i class="material-icons-outlined">golf_course</i>
            </div>
            <div class="sub-title">Missie</div>
            <p>
              Optimale zorg door efficiëntere planning. Met onze software kan
              enorm veel tijd en dus geld worden bespaard. Door de agenda’s van
              behandelaren en clienten direct af te stemmen op bijvoorbeeld de
              beschikbare ruimtes, kunnen er zeer snel behandelingen en
              afspraken worden ingepland. De tijd die hiermee wordt gewonnen kan
              dan ingezet worden in datgene waar het allemaal om draait, de zorg
              zelf. Hierdoor neemt de kwaliteit van de zorg ontzettend toe. Neem
              contact op voor meer informatie.
            </p>
          </div>
          <div class="col-12 offset-md-2 col-md-5 mission-vision-block">
            <div class="icon">
              <i class="material-icons-outlined">remove_red_eye</i>
            </div>
            <div class="sub-title">Visie</div>
            <p>
              Door de inzet van geavanceerde software maken wij het plan proces
              eenvoudig en volautomatisch. Hierdoor kan er met de wensen/eisen
              van patiënt, behandelaar en organisatie optimaal rekening gehouden
              worden. Dit geeft een hogere cliënt tevredenheid, kortere
              wachtlijsten, meer tevredenheid bij behandelaren en door dit alles
              betere zorg.
            </p>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  name: "OverOne",

  mounted() {},
  methods: {},
  metaInfo() {
    return {
      title: "Roosterplatform - Over one",
    };
  },
};
</script>

<style scoped lang="scss">
@import "../assets/css/colors.scss";
@import "../assets/css/variables.scss";

.hero {
  padding: 100px 0;
  min-height: 600px;
  p {
    font-size: $big;
  }
  h3 {
    opacity: 0.3;
    font-weight: 700;
  }
}

.team {
  display: flex;
  flex-wrap: wrap;
  .member {
    width: calc(25% - 30px);
    background: $white;
    border-radius: $border-radius;
    color: $text;
    padding: 20px;
    text-align: center;
    height: 300px;
    overflow: hidden;
    transition: $transition-long;
    margin: 0 15px 30px;

    .picture {
      margin: 0 0 20px;
      transition: $transition-long;
      margin-top: 0;

      img {
        border-radius: 50%;
      }
    }
    .description {
      margin-top: 20px;
      text-align: left;
      max-height: 0;
      overflow: hidden;
      transition: $transition-long;
    }
    &:hover {
      transform: scale(1.05);
      .picture {
        margin: 0 0 20px;
        margin-top: -200px;
      }
      .description {
        max-height: 200px;
      }
    }
  }
}
.mission-vision-block {
  .icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: $primary;
    color: $white;
    width: 68px;
    height: 68px;
    border-radius: $border-radius;
    margin-bottom: 20px;

    i {
      font-size: $h2;
    }
  }
}

@media (max-width: 991px) {
  .team .member {
    width: calc(50% - 30px);
  }
}
@media (max-width: 767px) {
  .hero {
    padding: 50px 0;
  }
  .team .member {
    width: 100%;
    margin: 0 0 30px;
  }
  .mission-vision-block {
    padding-left: 100px;
  }
}
</style>
